import createStore from '@frontend/store/common/specialStatement/createStore'

export default createStore('client')
